import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {MyApp} from './app.component';

import {ContactPage} from '../pages/contact/contact';
import {CrearOrdenPage} from '../pages/crear-orden/crear-orden';


import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';

import {TabsPage} from '../pages/tabs/tabs';
import {SocialSharing} from '@ionic-native/social-sharing';
import {CallNumber} from '@ionic-native/call-number';
import {DetalleOrdenPage} from "../pages/detalle-orden/detalle-orden";
import {OrdenProvider} from '../providers/orden/orden';
import {LoginPageModule} from "../pages/login/login.module";
import {AuthProvider} from '../providers/auth/auth';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {IonicStorageModule} from "@ionic/storage";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/first';
import {AuthInterceptor} from "../utils/auth-interceptor";
import { OrdensPage } from '../pages/ordens/ordens';
import { ComponentsModule } from '../components/components.module';
import { PipesModule } from '../pipes/pipes.module';
import { EditOrdenPage } from '../pages/edit-orden/edit-orden';
import { editOrder } from '../models/order';




@NgModule({
  declarations: [
    MyApp,
    DetalleOrdenPage,
    ContactPage,
    CrearOrdenPage,
    TabsPage,
    OrdensPage,
    EditOrdenPage

  ],
  imports: [
    BrowserModule,
    ComponentsModule,
    PipesModule,
    IonicModule.forRoot(MyApp),
    LoginPageModule,
    HttpClientModule,
    IonicStorageModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    DetalleOrdenPage,
    ContactPage,
    CrearOrdenPage,
    OrdensPage,
    EditOrdenPage

  ],
  providers: [
    StatusBar,
    SplashScreen,
    SocialSharing,
    CallNumber,
    OrdenProvider,
    {
      provide : HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi   : true,
    },
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    AuthProvider,
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts